import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

import ProductsList from "../LicenseManagement/ProductsList";

const StudentLicenseManagemenModal = ({
  preselectedStudents,
  className,
  toggle,
  isOpen,
}) => {
  const toggleModal = () => {
    toggle();
  };

  return (
    <Modal size="xl" isOpen={isOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}></ModalHeader>
      <ModalBody>
        <ProductsList
          preselectedStudents={preselectedStudents}
          className={className}
          inModal={true}
          closeModal={toggleModal}
        />
      </ModalBody>
    </Modal>
  );
};

export default StudentLicenseManagemenModal;
